module.exports = __webpack_public_path__ + "static/10-6765cdae2c3363c05ff66f8ab4afab13.jpg";